import { render, staticRenderFns } from "./IntakeInfo.vue?vue&type=template&id=9162ec12&"
import script from "./IntakeInfo.vue?vue&type=script&lang=js&"
export * from "./IntakeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports